import { COOLDOWN_KEY, COOLDOWN_MS } from '../constants';

export interface CooldownState {
  active: boolean;
  remainingMs: number;
  lastAttemptAt: number | null;
}

const safeStorage = (): Storage | null => {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return null;
    return window.localStorage;
  } catch {
    return null;
  }
};

export const getCooldown = (): CooldownState => {
  const storage = safeStorage();
  if (!storage) {
    return { active: false, remainingMs: 0, lastAttemptAt: null };
  }
  const raw = storage.getItem(COOLDOWN_KEY);
  if (!raw) {
    return { active: false, remainingMs: 0, lastAttemptAt: null };
  }
  const parsed = Number.parseInt(raw, 10);
  if (!Number.isFinite(parsed) || parsed <= 0) {
    return { active: false, remainingMs: 0, lastAttemptAt: null };
  }
  const now = Date.now();
  const elapsed = now - parsed;
  if (elapsed >= COOLDOWN_MS) {
    return { active: false, remainingMs: 0, lastAttemptAt: parsed };
  }
  return {
    active: true,
    remainingMs: COOLDOWN_MS - elapsed,
    lastAttemptAt: parsed,
  };
};

export const markAttempt = (): void => {
  const storage = safeStorage();
  if (!storage) return;
  storage.setItem(COOLDOWN_KEY, Date.now().toString());
};

export const clearCooldown = (): void => {
  const storage = safeStorage();
  if (!storage) return;
  storage.removeItem(COOLDOWN_KEY);
};
